// import './assets/scss/app.scss'
import { auth } from './library/firebase'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'
import VueSmoothScroll from 'vue2-smooth-scroll'
import Notifications from 'vue-notification'


Vue.config.productionTip = false
Vue.use(Notifications)
Vue.use(VueFormulate)
Vue.use(VueSmoothScroll, {
  updateHistory: false
})

let app

auth.onAuthStateChanged(user => {
  if (!app) {
    // Keep router details in vuex store
    const unsync = sync(store, router)

    app = new Vue({
      router,
      store,
      render: h => h(App),
      beforeDestroy() {
        unsync()
      }
    }).$mount('#app')
  }

  if (user) {
    if (!router.currentRoute.path.includes('signup')) {
      store.dispatch('fetchUserProfile', user)
    }
  }
})